// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"bridge-3"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 16.0004V21.0004M3 16.0004H2M3 16.0004H12M3 16.0004V3M21 16.0004V21.0004M21 16.0004H22M21 16.0004H12M21 16.0004V3M12 16.0004V3M3.5 6.33333L12 12L20.5 6.33333","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-bridge-3')
export default class Bridge3Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bridge-3',
    }
  }
}
